import { MIN_AMOUNT_BY_CURRENCY } from 'modules/Distances/constants';

export const getMinAmountByCurrency = (currency: string | undefined): number => {
  if (!currency) return 0;

  return MIN_AMOUNT_BY_CURRENCY[currency] || 0;
};
